/**
 * 配置管理器，用于游戏前端配置加载
 */
class ConfigManager {
    constructor() { }
    getInstance() {
        if (!this.instance) {
            this.instance = new ConfigManager();
        }
        return this.instance;
    }
    /**
     * 预加载指定配置文件
     * @param  {...any} 要加载的配置
     */
    load(...cfgNames) {
        return new Promise((resolve, reject) => {
            let pathList = cfgNames.map(name => `config/${name}.json`);
            ResManager.load(pathList).then((result) => {
                let dataMap = new Map();
                const dataList = result[0];
                for (let i = 0; i < dataList.length; i++) {
                    const data = dataList[i];
                    dataMap.set(cfgNames[i], data);
                }
                resolve(dataMap);
            }).catch((reason) => {
                reject(reason);
            });
        });
    }
    /**
     * 获取配置数据
     * @param {*} cfgName 配置名
     */
    get(cfgName) {
        return ResManager.get(`config/${cfgName}.json`);
    }
    /**
     * 释放配置数据占用的内存
     * @param  {...any} cfgNames 要释放的配置
     */
    release(...cfgNames) {
        ResManager.release(cfgNames.map(name => `config/${name}.json`), true);
    }
}
module.exports = ConfigManager;
